import React, { useCallback, FC } from 'react';

import { Button, ArrowRight } from 'Modules/ui';

import { useTransferLayoutContext, RegistersLayoutKeys } from '../../TransferLayout';
import styles from './index.module.scss';


export const TransferButton: FC = () => {
    const { currentTab, changeTab } = useTransferLayoutContext();
    const showFullView = useCallback(
        () => changeTab(RegistersLayoutKeys.RegistersView),
        [changeTab],
    );

    if (!currentTab)
        return null;

    return (
        <Button
            variant='auxiliary'
            className={styles.button}
            onClick={showFullView}
        >
            <ArrowRight />
        </Button>
    );
};
